import { toast } from "react-toastify";

type Rule = {
  value: unknown;
  label: string;
  type?: "string" | "array" | "image" | "number";
  min?: number;
};

export function validateForm(rules: Rule[]): boolean {
  for (const rule of rules) {
    const { value, label, type = "string", min } = rule;

    if (type === "string") {
      if (!value || (typeof value === "string" && !value.trim())) {
        toast.error(`${label} không được để trống`);
        return false;
      }
    }

    if (type === "array") {
      if (!Array.isArray(value) || value.length === 0) {
        toast.error(`${label} phải có ít nhất 1 mục`);
        return false;
      }
    }

    if (type === "image") {
      const img = value as { url?: string } | null | undefined;
      if (!img?.url) {
        toast.error(`Vui lòng chọn ${label}`);
        return false;
      }
    }

    if (type === "number") {
      const num = Number(value);
      if (isNaN(num) || (min !== undefined && num < min)) {
        toast.error(`${label} phải lớn hơn hoặc bằng ${min ?? 0}`);
        return false;
      }
    }
  }

  return true;
}
